// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__KKMEK","tab":"Tabs_tab__3Tcln","tabActive":"Tabs_tabActive__3mCTb"};